module.exports = __webpack_public_path__ + "img/logo_main_left_menu.62dd7bda.svg";